import http from "infra/http";
import { useQuery } from "react-query";
import { ReservaFiltroAdv } from "core/features/reservas/typings";
import { DashboardReservaValues } from "../typings";

function useDashboardReservas({ filtro }: { filtro: ReservaFiltroAdv }) {
  return useQuery([`/v1/reserva/dashboard`, filtro.tenantsIds], async () => {
    const { data } = await http.get<DashboardReservaValues>(
      `/v1/reserva/dashboard`,
      {
        params: filtro,
      }
    );
    return data;
  });
}

export default useDashboardReservas;
